// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"25afd777","122":"b4faab53","453":"124c5852"}[chunkId] + ".chunk.js";
};